"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("./helpers");
exports.default = (function (advisorEl) {
    var _a = advisorEl.dataset, advisorStatesServed = _a.advisorStatesServed, advisorIncome = _a.advisorIncome, advisorAssets = _a.advisorAssets, advisorOccupation = _a.advisorOccupation, advisorAge = _a.advisorAge, advisorFinancial_goalsconcerns = _a.advisorFinancial_goalsconcerns, locations = _a.locations;
    var advisor = {
        element: advisorEl,
        wizard: {
            income: advisorIncome ? helpers_1.parseAdvisorSettings(advisorIncome) : [],
            assets: advisorAssets ? helpers_1.parseAdvisorSettings(advisorAssets) : [],
            occupation: advisorOccupation ? helpers_1.parseAdvisorSettings(advisorOccupation) : [],
            age: advisorAge ? helpers_1.parseAdvisorSettings(advisorAge) : [],
            goals: advisorFinancial_goalsconcerns ? helpers_1.parseAdvisorSettings(advisorFinancial_goalsconcerns) : [],
        },
        statesServed: advisorStatesServed ? helpers_1.parseAdvisorStates(advisorStatesServed) : [],
        officeLocations: locations ? JSON.parse(locations) : []
    };
    return advisor;
});
